import { graphqlRequest } from "./graphql";

export interface Brand {
  brandId: string;
  brandName: string;
  about: string;
  logoURL: string;
  logoBlurhash: string;
  maxDiscount: number;
}

interface GetAllBrandsResponse {
  getAllBrandsByUser: Brand[];
}

export async function getAllBrands(userId: string, token: string): Promise<Brand[]> {
  const query = `
    query GetAllBrands($user_id: uuid!) {
      getAllBrandsByUser(request: { user_id: $user_id }) {
        brandId
        brandName
        about
        logoURL
        logoBlurhash
        maxDiscount
      }
    }
  `;
  const data = await graphqlRequest<GetAllBrandsResponse>(query, { user_id: userId }, token);
  return data.getAllBrandsByUser;
}
